import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-qr-approval-landing',
  templateUrl: './asset-qr-approval-landing.component.html',
  styleUrls: ['./asset-qr-approval-landing.component.scss']
})
export class AssetQrApprovalLandingComponent {

}
